export class PanelRoutes {
  static readonly panel = {
    tarifario: '/tarifario',
    cashinOut: '/user/cashin-cashout',
    cashYacare: '/user/account-yacare',
    branchOffices: '/user/branch-offices',
    profile: '/user/my-commerce',
    transfer: '/user/cashout/transfer'
  };
}
